import { useRef, useState } from "react";

export const useDownloadStatus = () => {
  const [statuses, setStatuses] = useState({});
  const inFlight = useRef({});

  const getStatus = (key) => statuses[key] || 'idle';

  const setStatus = (key, status) => {
    setStatuses((prev) => {
      const next = { ...prev };
      if (status === 'idle') {
        delete next[key];
      } else {
        next[key] = status;
      }
      return next;
    });
  };

  const reset = (key) => {
    if (inFlight.current[key]) {
      return;
    }
    setStatus(key, 'idle');
  };

  const run = (key, promiseFactory) => {
    if (inFlight.current[key] || statuses[key] === 'done') {
      return Promise.resolve();
    }

    inFlight.current[key] = true;
    setStatus(key, 'loading');

    return promiseFactory()
      .then((result) => {
        delete inFlight.current[key];
        setStatus(key, 'done');
        return result;
      })
      .catch((error) => {
        delete inFlight.current[key];
        setStatus(key, 'idle');
        throw error;
      });
  };

  return { getStatus, run, reset };
};

export default useDownloadStatus;
